const IMG = {
  hero: "https://images.unsplash.com/photo-1661925501942-b0c9a9eab08e?crop=entropy&cs=srgb&fm=webp&w=1200&q=75",
  guitar: "https://images.unsplash.com/photo-1525201548942-d8732f6617a0?crop=entropy&cs=srgb&fm=webp&w=800&q=70",
  keyboard: "https://images.unsplash.com/photo-1552422535-c45813c61732?crop=entropy&cs=srgb&fm=webp&w=800&q=70",
  composition: "https://images.unsplash.com/photo-1477233534935-f5e6fe7c1159?crop=entropy&cs=srgb&fm=webp&w=900&q=75",
  violin: "https://images.unsplash.com/photo-1566913485242-694e995731b4?crop=entropy&cs=srgb&fm=webp&w=800&q=70",
  flute: "https://images.unsplash.com/photo-1698912128482-6cdf4bcbfa3f?crop=entropy&cs=srgb&fm=webp&w=900&q=75",
  singing: "https://images.unsplash.com/photo-1608319917470-9d9179430f8d?crop=entropy&cs=srgb&fm=webp&w=800&q=70",
};

export { IMG };

// EDIT ME: skill card + pop-up content. Memberships/prices live in src/data/plans.js.
const DEFAULTS = {
  classFormat: "Group classes · 1 hour sessions",
};

export const COURSES = [
  {
    id: "guitar",
    name: "Guitar",
    tag: "Acoustic",
    tagline: "The instrument everyone sings along to.",
    image: IMG.guitar,
    alt: "Close-up of hands playing chords on an acoustic guitar",
    desc: "From your first open chord to full songs - strumming, fingerstyle and lead, the acoustic way.",
    levels: ["Chords & Strumming", "Fingerstyle & Theory", "Lead, Solos & Performance"],
    learnPoints: ["Open chords & strumming patterns", "Fingerstyle and basic theory", "Lead lines, solos & stage play", "Ear training built into every level", "Perform a full song by level 2"],
    ...DEFAULTS,
  },
  {
    id: "flute",
    name: "Flute",
    tag: "Wind & Breath",
    tagline: "Calm, breath-led melody.",
    image: IMG.flute,
    alt: "Musician playing a silver concert flute",
    desc: "Breath, tone and melody on the silver flute - calm practice that builds lung strength and focus.",
    levels: ["Tone & Breath", "Alankars & Melodies", "Songs & Expression"],
    learnPoints: ["Breath control & embouchure", "Alankars and melody phrasing", "Full songs with expression", "Tone development drills", "Stage-ready pieces"],
    ...DEFAULTS,
  },
  {
    id: "violin",
    name: "Violin",
    tag: "Strings & Bow",
    tagline: "Discipline that sounds beautiful.",
    image: IMG.violin,
    alt: "Violinist with the bow on the strings in warm light",
    desc: "Bow control, posture and intonation, taught patiently - the instrument rewards it.",
    levels: ["Posture & Bowing", "Scales & Intonation", "Pieces & Recital"],
    learnPoints: ["Posture, bow hold & strokes", "Scales & intonation training", "Pieces ready for recital", "Reading sheet music", "Ensemble playing basics"],
    ...DEFAULTS,
  },
  {
    id: "singing",
    name: "Singing",
    tag: "Vocals & Voice",
    tagline: "Your voice is the instrument.",
    image: IMG.singing,
    alt: "Singer performing with a microphone on stage in warm light",
    desc: "Voice training, pitch, breathing and stage confidence. Find your natural voice.",
    levels: ["Breath & Pitch", "Range & Tone", "Songs & Stage"],
    learnPoints: ["Pitch, breathing & vocal warm-ups", "Range, tone & voice care", "Perform songs with confidence", "Microphone technique", "Stage presence"],
    ...DEFAULTS,
  },
  {
    id: "keyboard",
    name: "Keyboard",
    tag: "Melody + Harmony",
    tagline: "Melody and harmony in two hands.",
    image: IMG.keyboard,
    alt: "Hands playing piano keyboard keys",
    desc: "Read, play and improvise. Notation, chords and both-hands coordination from day one.",
    levels: ["Keys & Notation", "Chords & Both Hands", "Improvisation & Grades"],
    learnPoints: ["Notes, notation & rhythm", "Chords with both hands", "Improvise & play by ear", "Accompany a singer", "Grade exam preparation"],
    ...DEFAULTS,
  },
  {
    id: "composition",
    name: "Music & Composition",
    tag: "Theory & Songwriting",
    tagline: "Write the songs others will learn.",
    image: IMG.composition,
    alt: "Producer workstation with MIDI keyboard controller and studio headphones",
    desc: "Turn ideas into songs - melody, harmony, structure and arrangement for writers and producers.",
    levels: ["Melody & Harmony", "Song Structure", "Arrangement & Demo"],
    learnPoints: ["Melody & harmony essentials", "Song structure & arrangement", "Lyrics that land", "Produce a demo of your own song", "Music theory in practice"],
    ...DEFAULTS,
  },
];

export const TESTIMONIALS = [
  { name: "Sneha Iyengar", meta: "Singing", rating: 5, quote: "A good serious teacher is rare, they are very well dedicated and skillfully creative teacher. Learning under TMH gives students confidence and makes one committed towards excelling." },
  { name: "Mayur Rathod", meta: "Writing & Composition", rating: 4.5, quote: "Really good experience at The Music Highway. The teachers are friendly, supportive and make learning music enjoyable. Definitely recommend it to anyone looking to learn music 🎶" },
  { name: "Ruchita Raju", meta: "Guitar", rating: 4.8, quote: "I've been learning guitar here and it's been a great experience so far. The teachers are true experts and clearly know their craft inside out. The lessons feel tailored to my pace and skill level. Beyond guitar, there's a lot of room to explore if you're interested in other instruments or singing and song writing too. Highly recommend for anyone serious about learning music!" },
  { name: "Vijaya Narkar", meta: "Flute", rating: 4.9, quote: "Joining this music class has been an incredible journey. I have improved a lot since I started, but it's so much more than just technical skill for me. Music has become a completely different connection, it's where I go to decompress and truly express myself. The environment here is so supportive, and it has genuinely changed how I experience music. Highly recommend!" },
  { name: "Viraj Narkar", meta: "Guitar", rating: 4.6, quote: "I wanted to share how much this class means to me. Not only have I seen massive improvement in my abilities, but it has unlocked a completely different level of connection to the music. Thank you for creating a space where I can grow both as a student and an artist." },
  { name: "Alex Melvin", meta: "Singing / Guitar", rating: 4.7, quote: "Best music classes in Sion! The Music Highway is amazing for anyone who wants to learn singing / guitar. Teachers are very patient and friendly, especially for beginners. Ambience is great and they focus on practical learning not just theory. Located right opposite Croma Store, Sion Koliwada - easy to find. Highly recommended if you're looking for hobby classes in Mumbai. Value for money!" },
  { name: "Shyamli Sharma", meta: "Keyboard", rating: 4.3, quote: "Have been learning Keyboard @The Music Highway for the past 5 months now.. Its a great place in Sion. The tutor and is really good and experienced. He is very good at teaching." },
  { name: "Aryan Salvi", meta: "Guitar", rating: 4, quote: "Great place to learn music teacher are amazing Good learning structure highly recommend" },
  { name: "Shruti Kedar", meta: "Guitar", rating: 4.5, quote: "I've been learning guitar at Music Highway and it has been a good experience. The classes are well structured and the teaching is easy to understand. Sir is patient and explains things properly, especially when it comes to the basics and techniques. The overall environment is comfortable and the classes are enjoyable. A good place for anyone who wants to learn guitar." },
];

// Line 1 = first story, line 2 = second story, and so on.
// To change a picture, replace the link on that line. To skip a story, leave its line empty.
// Drive files must be shared as "Anyone with the link can view" or the picture will not show.
export const STORY_PICTURES = [
  "https://drive.google.com/file/d/1oNVrN2U7cDSojqc22LUUnCPzOghTNqKm/view?usp=drivesdk",
  "https://drive.google.com/file/d/1_7ByEnLpac3HIPkQmJFizLFX8cAXDFpL/view?usp=drivesdk",
  "https://drive.google.com/file/d/1vUNBJ1MoizOEIhZp7gdjU1sA6oUt7SbH/view?usp=drivesdk",
  "https://drive.google.com/file/d/1DqaaYNXz4hLvShwYyNzbMeGZobfIk-bI/view?usp=drivesdk",
  "https://drive.google.com/file/d/10S1bpdZO-ZIxZg8FCZ1BW9kA_bkdhzyg/view?usp=drivesdk",
  "https://drive.google.com/file/d/1HGOiyIoff47vouaOXSiH3y9ql1y1P4X9/view?usp=drivesdk",
  "https://drive.google.com/file/d/1utvdqPnwVqRhjTwWjdGnalChQdWaf7Hi/view?usp=drivesdk",
  "https://drive.google.com/file/d/1ED-hkItn9MBj88xGqxgOpBOe6pHUIdn9/view?usp=drivesdk",
  "https://drive.google.com/file/d/1P6l38GUmK5dNoTVcgVHY7sdaX5ViJ144/view?usp=drivesdk",
];

// EDIT ME: About the Founder page content.
export const FOUNDER = {
  // The Drive file must be shared as "Anyone with the link can view" or the photo will not show.
  photoDriveLink: "https://drive.google.com/file/d/1sfa7XR5-1msaZQKPXL5P4-DXsX1VwtcM/view?usp=drivesdk",
  photoCaption: "Christopher Kandi, Founder",
  photoAlt: "Christopher Kandi, Founder of The Music Highway",
  eyebrow: "ABOUT THE FOUNDER",
  name: "Christopher Kandi",
  role: "Founder, The Music Highway",
  bio: "I am a Trinity certified guitarist. I am an independent artist, a writer, composer and singer, and I have composed more than 12 originals.",
  highlights: [
    { title: "Trinity Certified", label: "Guitarist" },
    { title: "Independent Artist", label: "Original music" },
    { title: "Writer, Composer & Singer", label: "Songs from lyrics to stage" },
    { title: "12+", label: "Originals composed" },
  ],
  storyTitle: "My Story",
  storyPoints: [
    "Started The Music Highway on 2 October 2023, in Ghatkopar, Mumbai",
    "One goal: a clear, direct route to real musical learning",
    "October 2026: 3 successful years done, stepping into the 4th",
    "Grateful to every student, parent and teacher who walked this road with me",
  ],
  storyBadge: "3 YEARS · Oct 2023 – Oct 2026",
  visionTitle: "My Vision",
  vision: [
    "The most trusted place in Mumbai to learn music seriously and joyfully",
    "Every student going from \"I want to learn\" to performing confidently on stage",
    "Growing TMH while keeping its quality and spirit",
  ],
  philosophyTitle: "My Philosophy",
  philosophy: [
    "Music is a highway: with a clear road, you reach your destination faster",
    "I cut the noise of wrong sounds, unwanted lessons and endless random videos",
    "Regular practice builds a musician, and every student learns at their own pace",
  ],
  valuesTitle: "My Values",
  values: [
    { title: "Seriousness with joy", desc: "Serious learning, always enjoyable" },
    { title: "Consistency", desc: "Small daily practice beats occasional bursts" },
    { title: "Practical learning", desc: "Playing, singing and performing, not just theory" },
    { title: "Support", desc: "No student is left alone after class" },
    { title: "Community", desc: "I celebrate every student's effort and growth" },
    { title: "Trust", desc: "I say what I do and do what I say" },
  ],
  quote: "After 3 years, the road is clear and the journey is just beginning. Come walk the highway with me.",
  ctaLabel: "Claim Free Check",
};

// EDIT ME: Life on Music Highway teaser + panel content.
export const LIFE = {
  title: "Life on Music Highway",
  subtitle: "Learn, perform and get rewarded along the way.",
  shortLine: "Rising Star of the Month and TMH Music Circle: recognition and rewards for every TMH student.",
  risingStar: {
    title: "Rising Star of the Month",
    intro: "Rising Star of the Month is TMH's monthly recognition for students.",
    points: ["A monthly award for one student", "Rewards progress and effort in learning"],
  },
  musicCircle: {
    title: "TMH Music Circle",
    intro: "TMH Music Circle is TMH's referral and rewards program for students. Students earn points for referrals, videos and performances.",
    rewards: [
      { title: "Refer a friend", points: "1,000 points" },
      { title: "Upload a video and tag TMH", points: "100 points per video", note: "up to 3 videos a month" },
      { title: "Perform at TMH Unplugged", points: "200 points" },
      { title: "Redeem", points: "3,500 points = 1 FREE month" },
    ],
    goalPoints: 3500,
    goalLabel: "3,500 points",
    goalReward: "1 FREE month",
  },
  unplugged: {
    title: "TMH Unplugged",
    intro: [
      "TMH Unplugged is our quarterly live music event, held every 3 months at a cozy local venue in Sion. It's where our students step out of the classroom and onto a real stage.",
      "There are no big lights or pressure, just music in its purest form: voices, guitars, keyboards and more, played live in front of family, friends and fellow music lovers.",
    ],
    // Drive file must be shared as "Anyone with the link can view" or the photo will not load.
    mainPhoto: {
      driveLink: "https://drive.google.com/file/d/18zTCBBlWECYCd8P6APMgTUowOp1m3EXy/view?usp=drivesdk",
      caption: "",
      altText: "TMH Unplugged live performance at Ista Cafe, Sion",
    },
    upcomingLabel: "Upcoming TMH Unplugged",
    upcomingText: "Date to be announced",
    eventNote: "",
    special: [
      { title: "A real stage for every student", desc: "Beginners and advanced learners perform together." },
      { title: "Confidence that lasts", desc: "Performing live builds courage that practice alone can't." },
      { title: "Family and friends invited", desc: "Parents get to see their child's progress first-hand." },
      { title: "Rewards for performing", desc: "Students earn TMH Music Circle points for taking the stage." },
      { title: "A warm community", desc: "Students, teachers and parents celebrate music together." },
    ],
    videosTitle: "What our students and parents say",
    // Drive files must be shared as "Anyone with the link can view" or the video will not play.
    // orientation: "horizontal" (16:9) or "vertical" (9:16, for reels)
    testimonialVideos: [
      { driveLink: "https://drive.google.com/file/d/1TA5xzE5wU8x0alxulQSxZIyam0fZ2cql/view?usp=drivesdk", name: "", caption: "", orientation: "horizontal" },
      { driveLink: "https://drive.google.com/file/d/1SFJaugoYQBtlsfE5Z3x1An61zNYRuWm8/view?usp=drivesdk", name: "", caption: "", orientation: "horizontal" },
      { driveLink: "https://drive.google.com/file/d/1d2Qw8VOq4yhsJKvHblZa5H2Nx5avi47e/view?usp=drivesdk", name: "", caption: "", orientation: "horizontal" },
      { driveLink: "https://drive.google.com/file/d/167sGHCZNPh95HOHDKD81bwzJITHSFRXV/view?usp=drivesdk", name: "", caption: "", orientation: "horizontal" },
      { driveLink: "https://drive.google.com/file/d/1EkNh244Y-Of-B2TrdPiR6eSg4dL7Obfe/view?usp=drivesdk", name: "", caption: "", orientation: "horizontal" },
      { driveLink: "https://drive.google.com/file/d/1GPR_r1f5_c3lufASK0--w-HkxDRFUFuq/view?usp=drivesdk", name: "", caption: "", orientation: "horizontal" },
    ],
    venueLine: "Our events are hosted in partnership. Get in touch to learn more about what is coming up.",
    closingTagline: "Learn it. Practice it. Perform it. Come be a part of the next TMH Unplugged!",
  },
  cta: { label: "Book Your 2 Trial Sessions", contact: "7738772358 | Sion, Mumbai" },
  closingCta: "Come experience it yourself. Play first, pay later.",
};

// EDIT ME: TMH Unplugged event page details - update date/time/venue when announced.
export const EVENT = {
  name: "TMH Unplugged",
  tagline: "An acoustic evening by the students of The Music Highway",
  date: "Saturday · Date announcing soon",
  time: "5 PM onwards",
  venue: "The Music Highway Studio, Sion East, Mumbai",
  description:
    "One evening, zero backing tracks. TMH Unplugged is our student showcase where guitars, keys, flutes, violins and voices take the stage in their rawest form. Come watch our students perform live - and maybe picture yourself up there next.",
  highlights: [
    { title: "Live acoustic sets", desc: "Solo and group performances by TMH students across all six skills." },
    { title: "Open mic", desc: "A few slots reserved for guests and budding performers." },
    { title: "Jam & mingle", desc: "Meet the teachers, jam with the crew, snacks on us." },
  ],
  membersBanner: "Silver, Gold and Platinum members get access to TMH Unplugged.",
  ctaText: "Reserve my seat on WhatsApp",
  waMessage: "Hey The Music Highway! I'd like to reserve a seat for TMH Unplugged.",
};

export const FAQS = [
  {
    q: "What is Play First, Pay Later?",
    a: "You get 2 free trial sessions on any instrument. If you love it, choose a membership. If not, you pay nothing. Valid for new students only; both sessions must be completed within 7 days of booking.",
  },
  {
    q: "How do I book my 2 free sessions?",
    a: "You can book by clicking the 'Book Your 2 Trial Sessions' button on our website, messaging us on WhatsApp at +91 77387 72358, or emailing themusichighway2@gmail.com.",
  },
  {
    q: "I have never played an instrument. Can I still join?",
    a: "Absolutely! Our structured roadmap takes you from beginner to stage, so you can start from zero and grow step by step.",
  },
  {
    q: "Do I have to bring my own instrument?",
    a: "Not at all! We provide all instruments, so you can simply walk in and start learning.",
  },
  {
    q: "What are your class timings?",
    a: "Timings differ for each skill. Fill in the inquiry form and we will help you find the right slot.",
  },
  {
    q: "What if I miss a class?",
    a: "Don't worry! One missed session every month is compensated, so you stay on track.",
  },
  {
    q: "What is TMH Unplugged?",
    a: "TMH Unplugged is our very own performance platform, where our students get to shine on stage.",
  },
  {
    q: "Do you teach both kids and adults?",
    a: "Yes. We run separate tracks for kids, teens and adult beginners - it is never too early or too late to start music.",
  },
];
